module.exports = __webpack_public_path__ + "static/media/sit-to-stand.9e1649e3.svg";